<ngx-aim-category-filter [categories]="(subCategories | async)!"></ngx-aim-category-filter>
@for (attribute of (attributes | async); track attribute) {
  <ngx-aim-attribute-filter [attribute]="attribute" [selectedAttributes]="(selectedAttributes | async)!"></ngx-aim-attribute-filter>
}
<ngx-aim-price-filter [minMax]="(minMax | async)!"></ngx-aim-price-filter>
